// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1182cff4","885":"bfb46937"}[chunkId] + ".chunk.js";
};